import { isNotDefined } from '@sgme/fp';

import type { BulkCashLeg, BulkLeg, BulkSwapLeg } from '@/store/bulkTrade/state.ts';

export function isCashLeg(leg: BulkLeg | undefined): leg is BulkCashLeg {
  if (isNotDefined(leg)) {
    return false;
  }

  return leg.type === 'Spot' || leg.type === 'Forward';
}

export function isSwapLeg(leg: BulkLeg | undefined): leg is BulkSwapLeg {
  if (isNotDefined(leg)) {
    return false;
  }

  return leg.type === 'Swap';
}
